import BaseService from '../../base/base_service';
import Event from '../../utils/event';
import DOM from '../../utils/dom';
import {SYSTEM_EVENTS} from '../../events/events';
import Device from '../../utils/device/device';
import _ from '../../utils/underscore';
import {TimeSpan} from "@sparkware/app-utils";
import Store from '../../utils/store';


export default class GameService extends BaseService {
    static CLASS = 'GameService';

    init(params) {
        super.init(params);
        this._resolveGameImagePath = params.resolveGameImagePath;
        this._openAnonymousGameApiUrl = params.openAnonymousGameApiUrl;

        if(params.GRS) {
            this._customChillUrl = params.GRS.CustomChillUrl;
            this._customGameResourcesPath = params.GRS.CustomGameResourcesPath;
            this._grsConfiguration = {
                gameState: params.GRS.GameState,
                additionalState: params.GRS.AdditionalState,
                gameTechnology: params.GRS.GameTechnology,
                GRSEnvironment: params.GRS.GRSEnvironment,
                enableVersionSending: params.GRS.enableVersionSending
            };
        }
    }

    resolveGameImagePath(imageFileName) {
        if(this._resolveGameImagePath) {
            return this._resolveGameImagePath(imageFileName);
        }
        const origin = this.serviceFactory.windowService().getLocationOrigin();

        return `${origin}/gamesImages/${imageFileName}`;
    }



    async closeRunningGame() {
        const isGameRunning = await this.serviceFactory.gameRunnerProxyService().isGameRunningLegacy
        if(isGameRunning) {
            await this.serviceFactory.gameRunnerProxyService().closeRunningGame();
        } else{
            if (Device.hybrid.isEmbedded && await this.isGameRunning()) {
                Event.fire(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_ALL);
            }
        }
    }

    isGameRunning() {
        return this.serviceFactory.gameRunnerProxyService().isGameRunningLegacy;
    }

    async isGameRunningInFreePlayMode() {
        if (!await this.isGameRunning()) {
            return false;
        }

        return await this.serviceFactory.gameRunnerProxyService().isGameRunningInFreePlayModeLegacy;
    }


    async getCurrentRunningGamecompanyName() {
        return await this.serviceFactory.gameRunnerProxyService().currentRunningGameCompanyNameLegacy;
    }

    async shouldShowRealityCheckMessageWhileGameIsOpen() {
        if(await this.serviceFactory.gameRunnerProxyService().isGameRunningLegacy) {
            return await this.serviceFactory.gameRunnerProxyService().shouldShowRealityCheckMessageWhileGameIsOpenLegacy();
        }
        return false;
    }

    async shouldShowTimeLimitMessageWhileGameIsOpen() {
        if(await this.serviceFactory.gameRunnerProxyService().isGameRunningLegacy) {
            return await this.serviceFactory.gameRunnerProxyService().shouldShowTimeLimitMessageWhileGameIsOpenLegacy();
        }

        return false;
    }

    async stopCurrentGameAutoplay() {
        // Relevant only for NYX AOD that still on second web view and not iframe
        if(await this.isGameRunning()) {
            // We wat delay here so the user will have enough time to see the reason of the closing game- for example big win.
            DOM.setTimeout(()=> {
                Event.fire(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_NYX);
            }, 5000);
        }

        if (await this.serviceFactory.gameRunnerProxyService().isGameRunningLegacy) {
            await this.serviceFactory.gameRunnerProxyService().stopCurrentGameAutoplayLegacy();
        }
    }

    async continuePlayCurrentGame() {
        if (await this.serviceFactory.gameRunnerProxyService().isGameRunningLegacy) {
            await this.serviceFactory.gameRunnerProxyService().continuePlayCurrentGameLegacy();
        }
    }


    _createCommonReadGameConfigurationRequest(gameOptions) {
        let request = {
            gameTypeId: gameOptions.gameType,
            isSupportFlash: false,
            isSupportHTML5: Device.isSupportHTML5,
            isMobile: Device.os.isMobileOS,
            GrsData: Store.get('GRSABTesting', ''),
            GameState: this._grsConfiguration.gameState,
            AdditionalState: this._grsConfiguration.additionalState,
            GameTechnology: this._grsConfiguration.gameTechnology,
            regulationId: this.serviceFactory.regulationService().getRegulationCode(),
            currencyCode: this.serviceFactory.currencyService().getCurrency(),
            languageCode: this.serviceFactory.languageService().getISO3(),
            currentRoute: this.serviceFactory.windowService().getPathName(),
            isHybridEmbedded: Device.hybrid.isEmbedded,
            productPackage: this.serviceFactory.skinService().getProductPackageID()
        };

        if (!_.isNullOrUndefined(gameOptions.vendorEnvironment)) {
            request.vendorEnvironment = gameOptions.vendorEnvironment;
        }

        if (this._grsConfiguration.GRSEnvironment) {
            request.GrsEnvironment = this._grsConfiguration.GRSEnvironment;
        }

        if (!_.isNullOrUndefined(gameOptions.useNetEntGameInclusion)) {
            request.useNetEntGameInclusion = gameOptions.useNetEntGameInclusion;
        }

        if (!_.isNullOrUndefined(gameOptions.useEvolutionNewIntegration)) {
            request.useEvolutionNewIntegration = gameOptions.useEvolutionNewIntegration;
        }

        if (!_.isNullOrUndefined(gameOptions.useAdapterIntegration)) {
            request.useAdapter = gameOptions.useAdapterIntegration;
        }

        if (false !== this._grsConfiguration.enableVersionSending) {
            let gameVersion = this.serviceFactory.hybridService().getCompiledGameVersion(gameOptions.gameType);
            if (gameVersion) { // better validation
                request.GameState = gameVersion;
            }
        }

        return request;
    }

    _handleGameConfigurationResult(gameConfigurationFromServer) {
        if(gameConfigurationFromServer.grsData) {
            let customChillUrl = this._customChillUrl;
            if(customChillUrl){
                gameConfigurationFromServer.grsData.chillUrl = customChillUrl;
            }

            if(this._customGameResourcesPath){
                gameConfigurationFromServer.grsData.customGameResourcesPath = this._customGameResourcesPath;
            }

            Store.set('GRSABTesting', gameConfigurationFromServer.grsData.abTestingData)
        }

        if(gameConfigurationFromServer.sessionTimer) {
            gameConfigurationFromServer.sessionTimer = TimeSpan.parse(gameConfigurationFromServer.sessionTimer);
        }

        return gameConfigurationFromServer;
    }

    readAnonymousGameConfiguration(gameOptions) {
        let requestParams = this._createCommonReadGameConfigurationRequest(gameOptions);

        return this.serviceFactory.http2Service()
            .post(this._openAnonymousGameApiUrl, requestParams)
            .then(gameConfiguration => this._handleGameConfigurationResult(gameConfiguration));
    }
}